import { Link } from "react-router-dom";

const LOGO_URL = "https://static.lumi.new/d6/d63fa18bf370e19b1dd3d4935c9dadef.webp";

const footerSections = [
{
  title: "Institucional",
  links: [
  { label: "Quem Somos", href: "/quem-somos" },
  { label: "Valores Organizacionais", href: "/valores-organizacionais" },
  { label: "Projetos Sociais", href: "/projetos-sociais" },
  { label: "Instituto Ponte", href: "/projetos-sociais-instituto-ponte" },
  { label: "Time de Atletas", href: "/time-de-atletas-ew" }]

},
{
  title: "Solucoes",
  links: [
  { label: "EW Pass", href: "/ewpass-plano-de-assinatura" },
  { label: "Nossos Produtos", href: "/nossos-produtos" },
  { label: "Metodo GO", href: "/metodo-go" },
  { label: "Teste de Nivel", href: "/teste-de-nivel" },
  { label: "Certificados", href: "/certificados" }]

},
{
  title: "Parcerias",
  links: [
  { label: "Nossos Convenios", href: "/nossos-convenios" },
  { label: "Seja Afiliado", href: "/seja-um-afiliado" },
  { label: "Seja Parceiro", href: "/seja-nosso-parceiro" }]

},
{
  title: "Suporte",
  links: [
  { label: "Blog", href: "/blog" },
  { label: "Fale Conosco", href: "/fale-conosco" },
  { label: "Area do Aluno", href: "#" }]

}];


export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-5 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img src={LOGO_URL} alt="English Work" className="h-12 w-auto mb-5 brightness-0 invert" />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Educacao em ingles pensada para o mundo real. Tecnologia, flexibilidade e resultados.
            </p>
            <div className="flex gap-3">
              {["App Store", "Google Play"].map((store) =>
              <span
                key={store}
                className="px-3 py-1.5 bg-gray-800 rounded-lg text-xs text-gray-300 border border-gray-700">
                  {store}
                </span>
              )}
            </div>
          </div>

          {/* Link Sections */}
          {footerSections.map((section) =>
          <div key={section.title}>
              <h4 className="font-bold text-sm uppercase tracking-wider mb-4" style={{ color: "#6CC4C4" }}>
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) =>
              <li key={link.href + link.label}>
                    <Link
                  to={link.href}
                  className="text-gray-400 text-sm hover:text-white transition-colors duration-200">
                      {link.label}
                    </Link>
                  </li>
              )}
              </ul>
            </div>
          )}
        </div>

        {/* Atendimento e Fale Conosco */}
        <div className="mt-12 pt-8 border-t border-gray-800 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-3" style={{ color: "#6CC4C4" }}>
              Atendimento
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed">
              De segunda a sexta-feira de 09h as 18h
            </p>
            <a
              href="https://wa.me/5527998797619"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-2 text-sm font-medium hover:opacity-80 transition-opacity duration-200"
              style={{ color: "#25D366" }}
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              +55 27 99879-7619
            </a>
          </div>
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-3" style={{ color: "#6CC4C4" }}>
              Fale Conosco
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed">
              CNPJ: 48.620.557/0001-51
            </p>
            <p className="text-gray-400 text-sm leading-relaxed mt-1">
              English Work Educacao Digital LTDA
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-gray-500 text-xs text-center md:text-left">
            <p>&copy; {new Date().getFullYear()} English Work. Todos os direitos reservados.</p>
          </div>
          <div className="flex gap-5">
            {["Instagram", "YouTube", "LinkedIn", "WhatsApp"].map((social) =>
            <a
              key={social}
              href="#"
              className="text-gray-500 hover:text-white text-xs transition-colors duration-200">
                {social}
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>);

}